import { render } from "./PurchaseSummary.vue?vue&type=template&id=287406ff"
import script from "./PurchaseSummary.vue?vue&type=script&lang=ts"
export * from "./PurchaseSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script